import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { PlatformEnum } from '@panamax/app-state';
import { PdpLnkSrc } from '@shared/constants/pdp-lnksrc.enum';
import { MerchandisingProductViewModel } from '@shared/models/merchandising-product-view.model';
import { QuantityUpdate } from '@shared/models/quantity-update';
import { Subject, Subscription, buffer, debounceTime } from 'rxjs';

@Component({
  selector: 'app-merchandising-product-carousel',
  templateUrl: './merchandising-product-carousel.component.html',
  styleUrls: ['./merchandising-product-carousel.component.scss'],
})
export class MerchandisingProductCarouselComponent
  implements OnInit, OnDestroy
{
  @Input() platformType: PlatformEnum;
  @Input() title: string;
  @Input() isGuestUser: boolean;
  @Input() products: MerchandisingProductViewModel[];
  @Input() linkSource: PdpLnkSrc;
  @Input() merchFeature = '';
  @Input() addMethod = '';

  @Output() quantityUpdateEmitter: EventEmitter<{
    quantityUpdate: QuantityUpdate;
    index: number;
    product: MerchandisingProductViewModel;
  }> = new EventEmitter();
  @Output() productImpressionsEmitter: EventEmitter<string[]> =
    new EventEmitter();
  @Output() productClickEmitter: EventEmitter<string> = new EventEmitter();

  readonly PlatformEnum = PlatformEnum;

  currentIntersectingIndexSet: Set<number> = new Set();
  seenProductSubscription$: Subscription;
  seenProductSubject$: Subject<string> = new Subject();

  ngOnInit() {
    this.seenProductSubscription$ = this.seenProductSubject$
      .pipe(buffer(this.seenProductSubject$.pipe(debounceTime(1000))))
      .subscribe(recTokens => {
        this.productImpressionsEmitter.emit(recTokens);
      });
  }

  ngOnDestroy() {
    this.seenProductSubscription$?.unsubscribe();
  }

  trackByIndex = (index: number, id: any) => index;

  onQuantityUpdate(
    event: QuantityUpdate,
    index: number,
    product: MerchandisingProductViewModel,
  ) {
    this.quantityUpdateEmitter.emit({ quantityUpdate: event, index, product });
  }

  onIntersectionChange(index: number, isIntersecting: boolean) {
    if (isIntersecting) {
      this.currentIntersectingIndexSet.add(index);
    } else {
      this.currentIntersectingIndexSet.delete(index);
    }
  }

  onProductImpression(recToken: string) {
    this.seenProductSubject$.next(recToken);
  }

  onProductClick(recToken: string) {
    this.productClickEmitter.emit(recToken);
  }
}
